<div class="download-asset-mode-title">
  <h1 class="title">Create Product Data File</h1>
  @if (isLoading) {
    <mat-spinner class="spinner"></mat-spinner>
  }
</div>
<mat-dialog-content class="download-asset-model">
  @if (!isLoading) {
    <div class="output-setting">
      <p class="description">
        Combines product label data and weights &amp; measures into files per product.
        Files will be uploaded to S3 and can be included in collections.
      </p>
      <div class="file-formats-section">
        <div class="file-formats-header">
          @if (selectedFormats.length > 0) {
            <mat-icon class="status-icon status-green">check_circle</mat-icon>
          } @else {
            <mat-icon class="status-icon status-error">error</mat-icon>
          }
          <span class="title" [class.error-title]="selectedFormats.length === 0">File Formats</span>
        </div>
        <app-select-all-checkbox
          class="select-all"
          [totalCount]="availableFormats.length"
          [selectedCount]="selectedFormats.length"
          (toggle)="toggleSelectAllFromShared($event)">
          Select all
        </app-select-all-checkbox>
        <div class="format-list">
          @for (format of availableFormats; track format) {
            <mat-checkbox
              class="custom-checkbox"
              color="primary"
              [checked]="isFormatSelected(format)"
              (change)="toggleFormat(format)">
              {{ format }}
              <code class="convention-inline">{{ formatConvention(format) }}</code>
            </mat-checkbox>
          }
        </div>
        @if (selectedFormats.length === 0) {
          <p class="format-error">Select at least one format.</p>
        }
      </div>
      @if (products.length > 0) {
        <app-product-label-data-list
          [products]="products"
          [batchId]="data.batchId"
          [filenameIdentifier]="filenameIdentifier"
          [availableFormats]="selectedFormats"
          [blockOnMissingPdfc]="true">
        </app-product-label-data-list>
      }
      @if (products.length > 0 && selectedFormats.length > 0) {
        <app-product-validation-list
          [products]="products"
          [validateProductDataExport]="true"
          [productDataFormats]="validationFormats"
          [productDataIdentifier]="validationIdentifier"
          [expectedAssets]="products.length * selectedFormats.length"
          [organizationId]="data.organizationId"
          (validationComplete)="onValidationComplete($event)">
        </app-product-validation-list>
        <p class="total-files-banner">{{ totalFilesText }}</p>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="action">
  <span style="flex: 1"></span>
  <button mat-stroked-button [mat-dialog-close]="DialogResult.Cancel">Cancel</button>
  <button mat-stroked-button color="success" class="save" cdkFocusInitial
    [disabled]="isCreateDisabled"
    (click)="generate()">
    @if (isGenerating) {
      <mat-icon><mat-spinner color="accent" diameter="20"></mat-spinner></mat-icon>
    }
    Create
  </button>
</mat-dialog-actions>
